import { verticals } from './verticals'

export const getRegisterInfluencerFormValues = values => {
  const verticalArray = Object.entries(values.verticals).reduce(
    (ac, [key, value]) => {
      if (value) {
        ac.push(key)
      }
      return ac
    },
    []
  )

  const addressArray = values.address.split(', ')

  return {
    ...values,
    verticals: verticalArray,
    address_new: {
      region: addressArray[0],
      province: addressArray[1],
      city: addressArray[2],
      barangay: addressArray[3],
      zip: values.postalCode,
      street: values.addressLine
    },
    region: addressArray[0]
  }
}

export const getProfileFormDefaultValues = values => {
  const getAddress = () => {
    if (values.address_new && values.address_new.region) {
      return {
        address: `${values.address_new.region}, ${values.address_new.province}, ${values.address_new.city}, ${values.address_new.barangay}`,
        postalCode: values.address_new.zip,
        addressLine: values.address_new.street
      }
    }
    return { address: values.address }
  }

  return {
    ...values,
    ...getAddress(),
    verticals:
      values?.verticals.reduce((ac, item) => {
        if (verticals.includes(item)) {
          ac[item] = true
        }

        return ac
      }, {}) ?? {}
  }
}
